module.exports = __webpack_public_path__ + "static/media/track-BG-3rd-layer-three@2x.1770c92a.png";